// Explication « Pourquoi ce score ? » : UNIQUEMENT à partir des matchs réellement retournés par zxcvbn
// (+ quelques constats structurels déterministes sur la saisie). Rien n'est journalisé ni transmis.
const dictKind = (name = "") => {
  if (name.startsWith("passwords")) return "commonPassword";
  if (name.startsWith("firstnames") || name.startsWith("lastnames")) return "name";
  if (name === "userInputs") return "userInput";
  return "word";
};

export function describeSegments(sequence = []) {
  return sequence.map((m) => {
    let kind = "random";
    if (m.pattern === "dictionary") kind = dictKind(m.dictionaryName);
    else if (m.pattern === "spatial") kind = "keyboard";
    else if (m.pattern === "sequence") kind = m.sequenceName === "digits" ? "numericSequence" : "alphaSequence";
    else if (m.pattern === "repeat") kind = m.baseToken && m.baseToken.length > 1 ? "repeatedPattern" : "repeat";
    else if (m.pattern === "regex" && m.regexName === "recentYear") kind = "year";
    else if (m.pattern === "date") kind = "date";
    return {
      token: m.token,
      kind,
      l33t: !!m.l33t,
      reversed: !!m.reversed,
      similar: m.levenshteinDistance != null && m.levenshteinDistance > 0,
    };
  });
}

// Liste dédoublonnée des faiblesses détectées (clés i18n tester.patterns.*).
export function detectedPatterns(password, sequence = []) {
  const segs = describeSegments(sequence);
  const found = new Set(segs.map((s) => s.kind).filter((k) => k !== "random"));
  if (segs.some((s) => s.l33t)) found.add("l33t");
  if (segs.some((s) => s.reversed)) found.add("reversed");
  if (segs.some((s) => s.similar)) found.add("similar");
  if (/(?:^|\D)(?:19|20)\d{2}(?!\d)/.test(password)) found.add("year"); // année 1900-2099 (constat factuel)
  if (/[A-Za-z]{3,}\d{1,4}[^\p{L}\p{N}]?$/u.test(password)) found.add("numericSuffix");
  if (/^[A-Z][a-z]{2,}/.test(password) && password.replace(/[^A-Z]/g, "").length === 1) found.add("predictableCapital");
  if (/[A-Za-z0-9][!?.@#$%&*+]{1,2}$/.test(password)) found.add("trailingSymbol");
  return Array.from(found);
}
